const commonHeaders = [
  'Date',
  'Particulars',
  'Type',
  'Contract NO',
  'Debit Amount',
  'Credit Amount',
  'Accounting Status',
  'Business Unit',
  'Entity',
];
const cashJournalHeaders = [
  'Date',
  'Particulars',
  'Type',
  'Contract NO',
  'Debit Amount',
  'Credit Amount',
  'Cash Receipt',
  'Accounting Status',
  'Business Unit',
  'Entity',
];
export const journalsTableHeaders = {
  salesJournal: [...commonHeaders],
  cashJournal: [...cashJournalHeaders],
  commissionJournal: [...commonHeaders],
  generalJournal: [...commonHeaders],
  trustJournal: [...commonHeaders],
};
